export * from './mapSettingsToText';
